module.exports = __webpack_public_path__ + "media/images/flags/fk-3613ea8b8f83dec5832fcfbae89c9142.svg";